import useAppTheme from 'hooks/useAppTheme';
import { useTagData } from '../hooks/useTagData';
import { ThemePalette } from 'mui.theme';
import { FlexBox, StyledTypography } from './SensorAnalysis.styles';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Chart } from '../SensorAnalysisView/Content/Chart/Individual/Chart';
import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setSelectedTags } from 'store/sensorAnalysis.slice';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface IndividualSensorAnalysisCardProps {
  tag: string;
  index: number;
}

export const IndividualSensorAnalysisCard = ({
  tag,
  index,
}: IndividualSensorAnalysisCardProps) => {
  const dispatch = useAppDispatch();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const tags = useAppSelector(
    (state) => state.sensorAnalysisReducer.selectedAsset?.device?.tags ?? []
  );
  const selectedTags = useAppSelector(
    (state) => state.sensorAnalysisReducer.selectedTags
  );

  const tagChartData = useAppSelector((state) => state.tagReducer.tagChartData);

  const { tagAliases, sortedSelectedTags } = useTagData();

  const tagData = useMemo(() => {
    const tagData = tagChartData?.find((item: any) => item.tagName === tag);
    return tagData;
  }, [sortedSelectedTags, tag, tagChartData]);

  const handleDeleteSelectedTag = (tagAlias: string) => {
    const clickedTag = tags?.find((item) => item.tagAlias === tagAlias);
    if (clickedTag) {
      const tagName = clickedTag.tagName;
      let updatedTags: string[] = [...selectedTags];
      const tagExists = selectedTags.find((item) => item === tagName);
      if (tagExists) {
        updatedTags = selectedTags.filter((item) => item !== tagName);
        dispatch(setSelectedTags(updatedTags));
      } else {
        console.error('No tag found!');
      }
    }
  };

  return (
    <div
      style={{
        border: `1px solid ${
          enableDarkTheme
            ? `${ThemePalette.typography.white}55`
            : `${ThemePalette.typography.black}55`
        }`,
        padding: '10px',
        borderRadius: '5px',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <FlexBox sx={{ justifyContent: 'space-between', height: 'fit-content' }}>
        <StyledTypography>{tagAliases[index]}</StyledTypography>
        <IconButton
          onClick={() => {
            handleDeleteSelectedTag(tagAliases[index]);
          }}
          color="secondary"
        >
          <Close fontSize="small" />
        </IconButton>
      </FlexBox>
      <div>
        <Chart data={tagData} tagName={tag} />
      </div>
    </div>
  );
};

export default IndividualSensorAnalysisCard;
